import { pxToRemValue } from "@ui/lib/utils";

function createSeededRandom(seed: number) {
  return () => {
    seed = (seed * 1103515245 + 12345) & 0x7fffffff;
    return seed / 0x7fffffff;
  };
}

// Section min/max are in px for readability, output is in rem
type WaveformSection = { weight: number; min: number; max: number };

export function generateWaveformHeights(count: number, sections: WaveformSection[], seed: number): number[] {
  const random = createSeededRandom(seed);
  const totalWeight = sections.reduce((sum, s) => sum + s.weight, 0);
  const heights: number[] = [];

  for (const section of sections) {
    const sectionCount = Math.round((count * section.weight) / totalWeight);
    for (let i = 0; i < sectionCount; i++) {
      const pxValue = section.min + random() * (section.max - section.min);
      heights.push(pxToRemValue(pxValue));
    }
  }

  return heights;
}

// Bar width in rem (~2.5px) - generates enough bars to fill ~31rem containers
export const WAVEFORM_BAR_WIDTH = pxToRemValue(2.5);
const WAVEFORM_BAR_COUNT = 200;

// Pre-computed at module load time - two different patterns for visual variety
export const WAVEFORM_HEIGHTS_1 = generateWaveformHeights(
  WAVEFORM_BAR_COUNT,
  [
    { weight: 1, min: 5, max: 14 }, // Left - quieter
    { weight: 1, min: 8, max: 20 }, // Middle - peaks
    { weight: 1, min: 8, max: 30 }, // Right - medium-tall
  ],
  42,
);

export const WAVEFORM_HEIGHTS_2 = generateWaveformHeights(
  WAVEFORM_BAR_COUNT,
  [
    { weight: 1, min: 6, max: 18 }, // Left - medium
    { weight: 1, min: 10, max: 28 }, // Middle - louder peaks
    { weight: 1, min: 5, max: 12 }, // Right - quieter fade out
  ],
  7,
);
